import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@components/shared/mixins/props';

/**
 * Textarea Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Make input direction RTL, LTR, Center, or Auto
     */
    @Prop({ default: 'auto' }) dir!: string;

    /**
     * Rows Count
     */
    @Prop() rows!: string | number;

    /**
     * Columns Count
     */
    @Prop() cols!: string | number;

    /**
     * Disable Resizing
     */
    @Prop({ type: Boolean }) noResize!: boolean;

    /**
     * Character Limit
     */
    @Prop({ default: 512 }) characterLimit!: string | number;
}

export default Props;
